module.exports = __webpack_public_path__ + "static/media/cb2_2x.26d95c11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/cb2_2x.jpg
// module id = 752
// module chunks = 27